// extracted by mini-css-extract-plugin
module.exports = {"tabLink":"styles-module__tabLink___3LhmI"};